var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_2051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.57297 1.42727C6.86998 0.724277 5.73022 0.724277 5.02732 1.42727L4.57732 1.87727C3.98449 2.4701 3.89377 3.3728 4.30093 4.06292L4.06306 4.30079C3.37285 3.89363 2.47015 3.98444 1.87732 4.57727L1.42732 5.02727C0.724421 5.73026 0.724421 6.86993 1.42732 7.57283C1.77877 7.92428 2.23948 8.10005 2.7001 8.10005C3.16072 8.10005 3.62143 7.92428 3.97297 7.57283L4.42297 7.12283C5.0158 6.53 5.10652 5.6273 4.69936 4.93718L4.93723 4.69931C5.21821 4.86509 5.53375 4.95005 5.8501 4.95005C6.31072 4.95005 6.77143 4.77428 7.12297 4.42283L7.57297 3.97283C8.27578 3.26993 8.27578 2.13017 7.57297 1.42727ZM3.78649 6.48644L3.33649 6.93644C3.16072 7.11221 2.9305 7.20005 2.7001 7.20005C2.4697 7.20005 2.23948 7.11221 2.06371 6.93644C1.71226 6.58499 1.71226 6.01511 2.06371 5.66357L2.51371 5.21357C2.74924 4.97813 3.08242 4.90127 3.38257 4.98119L3.28204 5.08172C3.10627 5.25749 3.10627 5.54243 3.28204 5.71811C3.3697 5.80613 3.48499 5.85005 3.6001 5.85005C3.71521 5.85005 3.8305 5.80613 3.91825 5.71829L4.01887 5.61767C4.09888 5.91782 4.02193 6.251 3.78649 6.48644ZM6.93649 3.33644L6.48649 3.78644C6.31072 3.96221 6.0805 4.05005 5.8501 4.05005C5.77189 4.05005 5.69377 4.03907 5.61772 4.01882L5.71825 3.91829C5.89402 3.74252 5.89402 3.45758 5.71825 3.2819C5.54266 3.10622 5.25754 3.10622 5.08195 3.2819L4.98133 3.38252C4.90141 3.08237 4.97827 2.7491 5.21371 2.51366L5.66371 2.06366C6.01525 1.71221 6.58495 1.71221 6.93658 2.06366C7.28803 2.41511 7.28803 2.98499 6.93649 3.33644Z",
    fill: "#084864"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_2051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.2694c34961ad167e95ea1b36deee9fe3.svg";
export { ForwardRef as ReactComponent };